import { Spacings } from "react-native-ui-lib";
import { SkeletonView } from "../SkeletonView";

export interface SkeletonBadgeProps {}

export function SkeletonBadge(props: SkeletonBadgeProps) {
  return (
    <SkeletonView
      width={80}
      height={24}
      style={{ borderRadius: Spacings.s2 }}
    />
  );
}
